import React from 'react';
import PropTypes from 'prop-types';
import useListStatusStyled from './hooks/useListStatus.styled';
import { Box, Grid } from '@material-ui/core';
import statusEnum from './status.enum';
import clsx from 'clsx';
import Collapse from '@material-ui/core/Collapse';

const ListStatusView = ({ viewModel, translations }) => {
  const styles = useListStatusStyled();

  const typeLabelStatus = (type) => {
    switch (type) {
      case statusEnum.APPROVED:
      case statusEnum.PASSED:
      case statusEnum.AUTOAPPROVED:
      case statusEnum.MANUALAPPROVED:
        return clsx(styles.label, styles.passsed);
      case statusEnum.FAILED:
      case statusEnum.DECLINED:
      case statusEnum.MANUALREJECTED:
        return clsx(styles.label, styles.failed);
      case statusEnum.NOT_APPLICABLE:
      case statusEnum.NOT_PERFORMED:
      case statusEnum.NEEDSAPPROVAL:
        return clsx(styles.label, styles.notPerformed);
      default:
        return clsx(styles.label, styles.failed);
    }
  };

  return (
    <Box className={styles.container}>
      <Collapse in={viewModel.expanded} timeout="auto" unmountOnExit>
        {viewModel.statuses.map((status, index) => (
          <Grid key={index} container spacing={2}>
            <Grid item xs={8}>
              <label className={styles.label}>{status.label}</label>
            </Grid>
            <Grid item xs={4} justifyContent="flex-end">
              <label className={typeLabelStatus(status.type)} style={{ textAlign: 'right' }}>
                {translations.statusTypeLabel(status.type)}
              </label>
            </Grid>
          </Grid>
        ))}
      </Collapse>
    </Box>
  );
};

ListStatusView.propTypes = {
  viewModel: PropTypes.object.isRequired,
  translations: PropTypes.object.isRequired,
};

export default ListStatusView;
